<template>
  <span class="copyable" @click.stop="copy" :title="`Kopieren: ${text}`">
    <slot />
    <i class="fas fa-copy copy-icon" />
    <transition name="copied-pop">
      <span v-if="copied" class="copied-toast">Kopiert! 📋</span>
    </transition>
  </span>
</template>

<script>
export default {
  name: 'Copyable',

  props: {
    text: { type: String, required: true }
  },

  data() {
    return { copied: false }
  },

  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.text)
      } catch {
        // Fallback for older browsers / non-HTTPS
        const el = document.createElement('textarea')
        el.value = this.text
        el.style.position = 'fixed'
        el.style.opacity = '0'
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
      }
      this.copied = true
      setTimeout(() => { this.copied = false }, 1500)
    }
  }
}
</script>

<style scoped>
.copyable {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  padding: 8px 14px;

  /* Much more transparent baseline */
  background: rgba(26, 102, 255, 0.08);

  /* Softer blur */
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);

  border-radius: 999px;

  /* Subtle, almost invisible border */
  border: 1px solid rgba(255, 255, 255, 0.12);

  /* Reduce shadow intensity */
  box-shadow:
      0 2px 8px rgba(0, 0, 0, 0.05);

  font-size: 14px;
  font-weight: 500;
  color: #0f172a;

  transition: all 0.25s ease;
}

/* Hover = visible + tactile */
.copyable:hover {
  background: rgba(26, 102, 255, 0.22);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  transform: translateY(-1px);

  box-shadow:
      0 6px 18px rgba(0, 0, 0, 0.12);
}

/* Active = pressed */
.copyable:active {
  transform: scale(0.97);
  box-shadow:
      0 2px 6px rgba(0, 0, 0, 0.1);
}

.copy-icon {
  font-size: 0.75em;
  color: #adb5bd;
  opacity: 0;
  transition: opacity 0.15s;
  flex-shrink: 0;
}

.copyable:hover .copy-icon {
  opacity: 1;
}

.copied-toast {
  position: absolute;
  bottom: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%);
  background: #212529;
  color: #fff;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 0.78rem;
  white-space: nowrap;
  pointer-events: none;
  z-index: 200;
}

.copied-pop-enter-active { transition: all 0.15s ease-out; }
.copied-pop-leave-active { transition: all 0.25s ease-in; }
.copied-pop-enter-from   { opacity: 0; transform: translateX(-50%) translateY(4px); }
.copied-pop-leave-to     { opacity: 0; transform: translateX(-50%) translateY(-4px); }
</style>
